import { Button, Form, Radio, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import type { PlatformType } from '@/types/authorization'
import { AUTH_PRIMARY_BUTTON_CLASS } from '../../constants'
import { platformOptions } from '../utils'
import { useSignup } from '../SignupContext'

export default function ProductStepForm() {
  const navigate = useNavigate()
  const { productForm, productSelection, setProductSelection, setStep, setError, loading } = useSignup()

  const handleNext = async () => {
    try {
      const values = await productForm.validateFields()
      setProductSelection({ product: values.product })
      setStep('info')
      setError(null)
    } catch {
      //
    }
  }

  return (
    <>
      <Form form={productForm} layout="vertical" initialValues={{ product: productSelection?.product }}>
        <Form.Item
          label={<span className="text-sm text-gray-700">Select a platform</span>}
          name="product"
          rules={[{ required: true, message: 'Please select a platform' }]}
        >
          <Radio.Group className="w-full">
            <Space direction="vertical" className="w-full">
              {platformOptions.map((option: { label: string; value: PlatformType }) => (
                <Radio value={option.value} key={option.value} className="text-[0.9375rem]">
                  {option.label}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </Form.Item>
      </Form>
      <div className="signup-step-actions">
        <Button onClick={() => navigate('/login')} disabled={loading}>
          Cancel
        </Button>
        <Button type="primary" loading={loading} disabled={loading} className={AUTH_PRIMARY_BUTTON_CLASS} onClick={() => void handleNext()}>
          Next
        </Button>
      </div>
    </>
  )
}
